import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	left: 60px;
	top: 140px;
	z-index: 4;
	width: 440px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 30px;

	transition: opacity 0.3s;
	opacity: 0;

	&.wheel-settings-enter {
		opacity: 0;
	}

	&.wheel-settings-enter-active,
	&.wheel-settings-enter-done,
	&.wheel-settings-exit {
		opacity: 1;
	}

	&.wheel-settings-exit-active {
		opacity: 0;
	}
`;

const StyledWheelSizeContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
`;

const StyledWheelSettingsItem = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 50px;
	padding: 10px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255,255,255,0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	div {
		${Text} {
			color: #ffffff;
			transition: color 0.3s ease;

			&:nth-child(1) {
				font-size: 12px;
				opacity: 0.25;
			}

			&:nth-child(2) {
				font-weight: 500;
				font-size: 14px;
			}
		}
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		div {
			${Text} {
				color: #000000;
			}
		}
	}
`;

const StyledSettingsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
`;

const StyledSettingsItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledSettingsItemTitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export {
	StyledContainer,
	StyledSettingsContainer,
	StyledSettingsItemContainer,
	StyledSettingsItemTitleContainer,
	StyledWheelSettingsItem,
	StyledWheelSizeContainer,
};
